import styled from '@emotion/styled';

export const ModalOverlay = styled.div<{ isOpen: boolean }>`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: #fff;
	display: flex;
	opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
	visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
	transition: all 0.3s ease;
	z-index: 99;
`;

export const CloseButton = styled.button`
	position: absolute;
	top: 20px;
	right: 20px;
	background: transparent;
	border: none;
	cursor: pointer;
	width: 3.2rem;
	height: 3.2rem;

	&::before,
	&::after {
		content: '';
		position: absolute;
		width: 3.2rem;
		height: 2px;
		background: #868e96;
		left: 50%;
		top: 50%;
	}

	&::before {
		transform: translate(-50%, -50%) rotate(45deg);
	}

	&::after {
		transform: translate(-50%, -50%) rotate(-45deg);
	}
`;

export const ModalContent = styled.ul`
	display: flex;
	width: 100%;
	margin-top: 5rem;
	flex-direction: column;
`;

export const MainMenu = styled.div`
	color: #212529;
	text-align: center;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-style: normal;
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
	text-transform: uppercase;
	text-decoration: none;
	display: flex;
	flex-direction: column;
	align-items: start;
	width: 100%;
	padding: 1.6rem 2rem;
	cursor: pointer;
`;

export const ModalSummary = styled.summary``;
export const SubMenu = styled.li`
	color: #343a40;
	text-align: center;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-style: normal;
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 100%;
	letter-spacing: -0.6px;
	text-transform: uppercase;
	text-decoration: none;
	background-color: #f8f9fa;
	width: 100%;
	padding: 2rem;
	display: flex;
	flex-direction: column;
	align-items: start;
`;
export const MainTextWithIcon = styled.div<{ isOpen: boolean }>`
	display: flex;
	opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
	visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
	transition: all 0.3s ease;
`;
export const TextWithIcon = styled.div<{ isOpen: boolean }>`
	display: flex;
	width: 100%;
	justify-content: space-between;
	cursor: pointer;
	opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
	visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
	transition: all 0.3s ease;
`;
export const NavLinks = styled.div`
	display: flex;
	align-items: center;
	gap: 4rem;
	white-space: nowrap;
	padding-left: 2rem;
	@media (max-width: 1180px) {
		display: none;
	}
`;
export const NavMoLinks = styled.div`
	display: flex;
	align-items: center;
	gap: 1.2rem;
	white-space: nowrap;
	padding-left: 2rem;
	@media (min-width: 1180px) {
		display: none;
	}
`;
export const NavMoLink = styled.div`
	color: #fff;
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	font-style: normal;
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
	line-height: 130%;
	letter-spacing: -0.6px;
`;
export const NavMoLinkLogin = styled.a`
	color: #fff;
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	font-style: normal;
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
	line-height: 130%;
	letter-spacing: -0.6px;
	padding: 0.6rem;
`;
export const NavLink = styled.a`
	color: #fff;
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-style: normal;
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
	line-height: 130%;
	letter-spacing: -0.6px;
`;

export const ButtonGroup = styled.div`
	display: flex;
	gap: 1rem;
`;

export const Button = styled.button<{ primary?: boolean }>`
	color: #fff;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-style: normal;
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
	line-height: 4rem;
	text-transform: upper case;
	padding: 0px 2.5rem 0px 2.3rem;
	border-radius: 3rem;
	display: flex;
	align-items: center;
	gap: 0.5rem;
`;

export const BoundaryLine = styled.div<{ primary?: boolean }>`
	background: #e0dfe3;
`;
export const ImgBox = styled.div`
	width: 23.4rem;
	height: 7rem;
	@media screen and (max-width: 1180px) {
		width: unset;
		height: 3.8rem;
	}
	img {
		width: 100%;
		height: 100%;
	}
`;
